// extracted by mini-css-extract-plugin
export default {"section":"MembershipDetailsList_section__aAdup"};